export default function traductionMessagesErreur(messagesErreur) {
  const messages = [];

  messagesErreur.forEach((message) => {
    if (message.indexOf('NO_LINE_FOR_MATERIEL_AND_YEAR') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'detailProduitReseau.popUpInfoTlpe.errors.noLineForMateriel',
        parametres: { anneeBase: splitMessage[2] },
      });
    }
    if (message.indexOf('SHOULD_HAVE_SURFACE') === 0) {
      messages.push({
        message: 'detailProduitReseau.popUpInfoTlpe.errors.shouldHaveSurface',
      });
    }
    if (message.indexOf('SHOULD_BE_LINKED_TO_FACE') === 0) {
      messages.push({
        message: 'detailProduitReseau.popUpInfoTlpe.errors.shouldBeLinkedToFace',
      });
    }
  });
  return messages;
}
